/*
 * @Author: your name
 * @Date: 2022-03-02 09:37:28
 * @LastEditTime: 2022-03-02 13:05:27
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyCheckBoxGroup\index.jsx
 */
import React, { Component } from 'react';
import "./index.css"

class BsyCheckBoxGroup extends Component {
    checkChange = (val) => {
        return (event) => {
            const { value } = this.props;
            if (value.indexOf(val) > -1) {
                value.splice(value.indexOf(val), 1)
                event.currentTarget.classList.remove("select");
            } else {
                value.push(val);
                event.currentTarget.classList.add("select");
            }
            this.props.onStopEdit && this.props.onStopEdit(value)
        }
    }
    render() {
        const { items, value, className } = this.props;
        return (
            <div className={`BsyCheckBox ${className}`}>
                {
                    items && items.map((val) => {
                        return <div onClick={this.checkChange(val.value)} className={"x-item-check data-label-type " + (value.indexOf(val.value) > -1 ? "select" : "")}><i className="icon-blank" /><span>{val.text}</span></div>
                    })
                }
            </div>
        );
    }
}

export default BsyCheckBoxGroup;
